import { Link } from 'react-router-dom';

export default function ProjectsSection() {
  const projects = [
    {
      title: 'Fabrika Fiber Altyapı Projesi',
      location: 'Gebze OSB',
      image: 'https://public.readdy.ai/ai/img_res/0e8b712d42e8b063925ef821061d3f74.jpg',
      category: 'Fiber Optik',
      link: '/hizmetlerimiz/fabrika-fiber-altyapi-projesi'
    },
    {
      title: 'Sanayi Bölgesi Kamera Sistemi',
      location: 'Tuzla OSB',
      image: 'https://readdy.ai/api/search-image?query=industrial%20security%20camera%20system%20installation%20in%20manufacturing%20facility%2C%20multiple%20IP%20cameras%2C%20professional%20surveillance%20equipment%2C%20factory%20security%20monitoring%2C%20high-tech%20industrial%20setting&width=800&height=600&seq=project-industrial-camera&orientation=landscape',
      category: 'Güvenlik Sistemleri',
      link: '/hizmetlerimiz/sanayi-bolgesi-kamera-sistemi'
    },
    {
      title: 'Metro Ethernet Fiber Ek',
      location: 'İstanbul Anadolu',
      image: 'https://readdy.ai/api/search-image?query=metro%20ethernet%20fiber%20optic%20splicing%20work%20with%20fusion%20splicer%20in%20telecommunications%20room%2C%20professional%20fiber%20connection%2C%20network%20infrastructure%2C%20clean%20technical%20environment%2C%20organized%20cable%20management&width=800&height=600&seq=project-metro-ethernet&orientation=landscape',
      category: 'Fiber Optik',
      link: '/hizmetlerimiz/metro-ethernet-fiber-ek'
    },
    {
      title: 'Bina Yangın Alarm Sistemi',
      location: 'Kadıköy',
      image: 'https://readdy.ai/api/search-image?query=modern%20building%20fire%20alarm%20system%20control%20panel%20with%20smoke%20detectors%20in%20office%20building%2C%20professional%20safety%20equipment%2C%20red%20emergency%20indicators%2C%20clean%20corporate%20interior%2C%20security%20installation&width=800&height=600&seq=project-fire-alarm&orientation=landscape',
      category: 'Güvenlik Sistemleri',
      link: '/hizmetlerimiz/bina-yangin-alarm-sistemi'
    },
    {
      title: 'OSB Geçiş Kontrol Sistemi',
      location: 'Kocaeli',
      image: 'https://readdy.ai/api/search-image?query=industrial%20access%20control%20system%20with%20turnstiles%20and%20barriers%20at%20factory%20entrance%2C%20security%20gates%2C%20professional%20industrial%20facility%20entrance%2C%20high-tech%20security%20equipment%2C%20organized%20industrial%20zone&width=800&height=600&seq=project-access-control&orientation=landscape',
      category: 'Güvenlik Sistemleri',
      link: '/hizmetlerimiz/osb-gecis-kontrol-sistemi'
    },
    {
      title: 'Acil Fiber Arıza Müdahalesi',
      location: 'Bursa',
      image: 'https://readdy.ai/api/search-image?query=emergency%20fiber%20optic%20cable%20repair%20technician%20working%20with%20fusion%20splicer%20equipment%2C%20urgent%20repair%20service%2C%20professional%20tools%2C%20industrial%20setting%2C%20night%20emergency%20response&width=800&height=600&seq=project-emergency-fiber&orientation=landscape',
      category: 'Fiber Optik',
      link: '/hizmetlerimiz/acil-fiber-ariza-mudahalesi'
    }
  ];

  return (
    <section id="hizmetlerimiz" className="py-20 bg-gradient-to-b from-slate-900 to-slate-800">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Hizmetlerimiz
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Fiber optik ve güvenlik sistemleri alanında gerçekleştirdiğimiz profesyonel projeler
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <Link 
              key={index}
              to={project.link}
              className="group bg-slate-800/50 backdrop-blur-sm rounded-2xl overflow-hidden border border-cyan-500/20 hover:border-cyan-500/50 transition-all duration-300 hover:transform hover:scale-105 cursor-pointer"
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4">
                  <span className="px-4 py-2 bg-cyan-500/90 backdrop-blur-sm text-white text-sm font-bold rounded-full">
                    {project.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-cyan-400 transition-colors">
                  {project.title}
                </h3>
                <div className="flex items-center text-gray-400 mb-4">
                  <i className="ri-map-pin-line mr-2"></i>
                  <span>{project.location}</span>
                </div>
                <div className="flex items-center text-cyan-400 font-semibold group-hover:translate-x-2 transition-transform">
                  <span>Detaylı Bilgi</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}